"use client";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { CustomEase } from "gsap/CustomEase";

// Register plugins once
gsap.registerPlugin(ScrollTrigger, CustomEase);

// Attach to window (for global access)
if (typeof window !== "undefined") {
  // @ts-ignore
  window.gsap = gsap;
}

export default gsap;
